import React from 'react';
import PropTypes from 'prop-types';
import Datatable from '../Datatable/';
import api from '../../api';

export const handleClickUpdateTableCallHistory = async (
  setIsFetching,
  setTableDataCallHistory
) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user._id && user.departments) {
      setIsFetching(true);
      const intervalStart = new Date();
      const intervalEnd = new Date();
      intervalStart.setHours(0, 0, 0, 0);
      intervalEnd.setHours(23, 59, 59, 59);
      const obj = {
        users: [user._id],
        departments: [...user.departments],
        interval: [intervalStart, intervalEnd],
        fields: [
          'type',
          'agent',
          'extension',
          'total_time',
          'client',
          'result',
          'restime',
          'tanswering'
        ],
        events: ['calls'],
        extensions: [],
        details: [],
        groups: [],
        lines: [],
        clients: []
      };
      const response = await api().post('/api/reports/events', obj);
      setTableDataCallHistory([...response.data]);
    }
  } catch (err) {
    console.error(err);
  } finally {
    setIsFetching(false);
  }
};

const CallHistory = props => {
  const {
    isFetching,
    setIsFetching,
    tableDataCallHistory,
    setTableDataCallHistory
  } = props;

  const columns = [
    {
      title: 'Tipo',
      data: 'type',
      render: data => data || '---'
    },
    {
      title: 'Cliente',
      data: 'client',
      render: data => data || '---'
    },
    {
      title: 'Hora',
      data: 'restime',
      render: data => data.split(' ')[1] || '---'
    }
  ];

  const dom = `
    <"filter-table-history"f>
    <"table-history table-responsive"rt>
    <"info-table-history"i>
    <"pagination-table-history"p>
    <"clear">`;

  return (
    <React.Fragment>
      <li>
        <div className="form-group m-2">
          <button
            type="button"
            className="btn btn-info btn-block font-weight-bolder"
            disabled={isFetching}
            onClick={() =>
              handleClickUpdateTableCallHistory(
                setIsFetching,
                setTableDataCallHistory
              )
            }
          >
            <i className="fa fa-sync" />
            &nbsp;ATUALIZAR TABELA
          </button>
        </div>
      </li>
      <li>
        <div className="call-history-table ml-2 mr-2">
          <Datatable
            data={tableDataCallHistory}
            columns={columns}
            order={[[2, 'asc']]}
            dom={dom}
            lengthChange={false}
          />
        </div>
      </li>
    </React.Fragment>
  );
};

CallHistory.propTypes = {
  isFetching: PropTypes.bool,
  setIsFetching: PropTypes.func,
  tableDataCallHistory: PropTypes.array,
  setTableDataCallHistory: PropTypes.func
};

export default CallHistory;
